"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var SfilterSortAction;
(function (SfilterSortAction) {
    SfilterSortAction.ON_SFILTER_CHANGE_SORT = 'ON_SFILTER_CHANGE_SORT';
    SfilterSortAction.ON_TOGGLE_SORT_SECTION = 'ON_TOGGLE_SORT_SECTION';
    SfilterSortAction.TOGGLE_SORT_SECTION = 'TOGGLE_SORT_SECTION';
    SfilterSortAction.onChangeSort = typesafe_actions_1.createAction(SfilterSortAction.ON_SFILTER_CHANGE_SORT, function (resolve) { return function (id) { return resolve(id); }; });
    SfilterSortAction.onToggleSortSection = typesafe_actions_1.createAction(SfilterSortAction.ON_TOGGLE_SORT_SECTION, function (resolve) { return function () { return resolve(); }; });
    SfilterSortAction.toggleSortSection = typesafe_actions_1.createAction(SfilterSortAction.TOGGLE_SORT_SECTION, function (resolve) { return function (state) { return resolve(state); }; });
})(SfilterSortAction || (SfilterSortAction = {}));
exports.default = SfilterSortAction;
